import { __awaiter, __generator } from "tslib";
import { SelectTileGroupKey } from '.';
import { createInternalSelectTileDriver } from './internal-select-tile/driver';
export var createSelectTileGroupDriver = function (wrapper) {
    var base = wrapper.$("." + SelectTileGroupKey);
    return {
        getSelected: function () { return base.$('.select-tile.checked').attr('data-value'); },
        getLabelByIdx: function (idx) { return base.$$('.select-tile').get(idx).$('.select-tile-label').text(); },
        clickTileByValue: function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var elem, internalTileDriver;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        elem = base.$$('.select-tile').filter(function (i) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, i.attr('data-value')];
                                case 1: return [2 /*return*/, (_a.sent()) === value];
                            }
                        }); }); }).get(0) || '';
                        if (!elem) return [3 /*break*/, 2];
                        internalTileDriver = createInternalSelectTileDriver(elem);
                        return [4 /*yield*/, internalTileDriver.selectTile()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        isContentRenderedByValue: function (value) { return __awaiter(void 0, void 0, void 0, function () {
            var elem, internalTileDriver, isExist;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.$$('.select-tile').filter(function (i) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, i.attr('data-value')];
                                case 1: return [2 /*return*/, (_a.sent()) === value];
                            }
                        }); }); }).get(0)];
                    case 1:
                        elem = _a.sent();
                        if (!elem) return [3 /*break*/, 3];
                        internalTileDriver = createInternalSelectTileDriver(elem);
                        return [4 /*yield*/, internalTileDriver.rendersContentByClassName(value)];
                    case 2:
                        isExist = _a.sent();
                        return [2 /*return*/, isExist];
                    case 3: return [2 /*return*/, false];
                }
            });
        }); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map